import MenuOptions from "../../components/order/menu/MenuOptions";

export default function PointsMissionsMenu({
  order,
  mobile,
  onDelete,
  onEdit,
}) {
  const menu = [
    {
      label: "Edit mission",
      action: () => {
        onEdit?.();
      },
      visible: true,
    },
    {
      label: "Delete mission",
      action: () => {
        onDelete?.();
      },
      visible: true,
    },
  ];

  return (
    <>
      <div className="hidden"></div>
      <MenuOptions mobile={mobile} menu={menu} />
    </>
  );
}
// Stay menu
